import React from 'react';

import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';

type CentralProcessingActivity = {
  name: string;
  description: string;
  processingRole: string;
  dataSubjectCategories: string[];
  personalDataCategories: string[];
  recipientCategories: string[];
  minimumSecurityMeasures: string[];
  purposes: Array<{
    name: string;
    legalBasis: string;
    legalBasisComment: string;
    liaRequired: boolean;
    retentionRule: string;
  }>;
};

type Props = {
  activity: CentralProcessingActivity;
};

const renderList = (items: string[]) => (items.length > 0 ? items.join(', ') : '—');

const ProcessingActivitySidePanel: React.FC<Props> = ({ activity }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const messages = processing_activities_messages.asset_ropa.apa_side_panel;

  return (
    <aside className={styles.sidePanel}>
      <Typography gutterBottom variant='h3'>
        {t(messages.title)}
      </Typography>
      <Typography color='textSecondary' gutterBottom variant='body2'>
        {t(messages.read_only_note)}
      </Typography>
      <div className={styles.fieldList}>
        <div>
          <div className={styles.fieldLabel}>{t(messages.name)}</div>
          <div>{activity.name}</div>
        </div>
        <div>
          <div className={styles.fieldLabel}>{t(messages.description)}</div>
          <div>{activity.description}</div>
        </div>
        <div>
          <div className={styles.fieldLabel}>{t(messages.processing_role)}</div>
          <div>{activity.processingRole}</div>
        </div>
        <div>
          <div className={styles.fieldLabel}>{t(messages.data_subjects)}</div>
          <div>{renderList(activity.dataSubjectCategories)}</div>
        </div>
        <div>
          <div className={styles.fieldLabel}>{t(messages.personal_data)}</div>
          <div>{renderList(activity.personalDataCategories)}</div>
        </div>
        <div>
          <div className={styles.fieldLabel}>{t(messages.recipients)}</div>
          <div>{renderList(activity.recipientCategories)}</div>
        </div>
        <div>
          <div className={styles.fieldLabel}>{t(messages.minimum_security)}</div>
          <div>{renderList(activity.minimumSecurityMeasures)}</div>
        </div>
      </div>
      {activity.purposes.map(purpose => (
        <div key={purpose.name} className={styles.fieldList} style={{ marginTop: 16 }}>
          <Typography gutterBottom variant='h4'>
            {purpose.name}
          </Typography>
          <div>
            <div className={styles.fieldLabel}>{t(messages.legal_basis)}</div>
            <div>{purpose.legalBasis}</div>
          </div>
          <div>
            <div className={styles.fieldLabel}>{t(messages.legal_basis_comment)}</div>
            <div>{purpose.legalBasisComment || '—'}</div>
          </div>
          <div>
            <div className={styles.fieldLabel}>{t(messages.lia_required)}</div>
            <div>{purpose.liaRequired ? t(messages.yes) : t(messages.no)}</div>
          </div>
          <div>
            <div className={styles.fieldLabel}>{t(messages.retention_rule)}</div>
            <div>{purpose.retentionRule}</div>
          </div>
        </div>
      ))}
    </aside>
  );
};

export default ProcessingActivitySidePanel;
